// Story 7.10 (ADO-906) — shared show/hide state for the attribute filter panel,
// used by BOTH the Browse listing and the Search screen so the two surfaces don't
// diverge (code-review 2026-07-13). Lives next to api/facets.ts, the other piece
// of facet plumbing both surfaces share.
//
// The panel is a persistent sidebar on desktop (shown by default, still dismissable
// — Figma "Filters Off" 615:3202) and hidden-by-default on small screens (toggled
// open via the Filters Switch). `matchMedia` is guarded for the test/SSR env where
// it may be absent.
import { useState } from 'react';

/** The viewport at/above which the panel defaults to open (desktop sidebar). */
const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';

/** Seed the panel open on desktop, closed on small screens (SSR/test → closed). */
function defaultShowFilters(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(DESKTOP_MEDIA_QUERY).matches
    : false;
}

export interface FilterPanelState {
  /** Whether the filter panel is currently shown. */
  readonly showFilters: boolean;
  /** Toggle the panel open/closed — the Filters Switch `onClick` handler. */
  readonly toggleFilters: () => void;
}

/** Owns the attribute filter panel's show/hide state + its toggle, seeded from the
 *  viewport. Extracted so Browse and Search share one behaviour. */
export function useFilterPanel(): FilterPanelState {
  const [showFilters, setShowFilters] = useState(defaultShowFilters);
  const toggleFilters = () => setShowFilters((v) => !v);
  return { showFilters, toggleFilters };
}
